import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "consts";
import { FinanceCategoryForm, FinanceCategoryFormValues } from "./FinanceCategoryForm/FinanceCategoryForm";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { courseFinanceCategoriesApi, useCourseFinanceCategory } from "api/course-finances";
import { useToaster } from "utils";

export const FinanceCategoryEditPage = (): JSX.Element | null => {
  const { id } = useParams();
  const { loading, data } = useCourseFinanceCategory(Number(id));
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  if (loading || data === null) return null;

  const onSubmit = async (values: FinanceCategoryFormValues) => {
    try {
      await courseFinanceCategoriesApi.update(data.id, values);
      navigate(routes.COURSE_FINANCES_CATEGORIES);
      showSuccess("Kategoria została zapisana");
    } catch (e) {
      showError("Wystąpił błąd podczas zapisywania kategorii");
      console.error(e);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        headerText="Edytuj kategorię płatności"
        breadcrumbs={[
          { title: "Finanse", path: routes.FINANCES },
          { title: "Kategorie płatności", path: routes.COURSE_FINANCES_CATEGORIES },
          { title: data.name },
        ]}
      />
      <FinanceCategoryForm {...data} onSubmit={onSubmit} />
    </PageMain>
  );
};
